/* eslint-disable indent,quote-props,no-unused-vars,dot-notation,padded-blocks,no-,no-restricted-syntax */
/**
 * Details Controller file
 * @class
 */
import vasActivationModalTemplate from '../SavedWithSuccessModal.html';
import suggestToMakeMenuTemplate from '../SuggestToMakeMenuModal.html';

class orderAndDeliveryController {



  /* @ngInject */

  constructor($log, $q, $scope, $timeout, MerchantConfigurationService,
              MerchantVasService, StorageService, $rootScope, ModalFactory,
              TermsService, NewTokenService, CatalogService) {


    const that = this;
    that.currentVasTypeId = MerchantVasService.getVasesTypes()['ORDER-AND-DELIVERY'];
    that.currentWalletId = NewTokenService.getMerchantWalletID();
    that.isSuperAdmin = StorageService.getLocalStorage('superAdmin');
    that.vasMenus = {};

    this.showVasConfigurationMenuError = () => {
      const closeModal = () => {
        modal.deactivate();
        $timeout(modal.destroy, 1000);
      };

      const modal = new ModalFactory({
        overlay: true,
        overlayClose: true,
        template: suggestToMakeMenuTemplate,
        class: 'default',
        contentScope: {
          okFunc: closeModal
        }
      });

      modal.activate();
    };

    this.showVasConfigurationSuccess = () => {
      const closeModal = () => {
        modal.deactivate();
        $timeout(modal.destroy, 1000);
      };

      const modal = new ModalFactory({
        overlay: true,
        overlayClose: true,
        template: vasActivationModalTemplate,
        class: 'default',
        contentScope: {
          okFunc: closeModal
        }
      });

      modal.activate();
    };

    that.save = () => {

      that.currentVas.configuration.deliveryArea = that.getShapes();

      that.currentVas.configuration.openingHours = that.getDays();

      if (that.currentVas.configuration.deliveryCost) {
        that.currentVas.configuration.deliveryCost = toCents(that.currentVas.configuration.deliveryCost);
      }
      if (that.currentVas.configuration.deliveryThreshold) {
        that.currentVas.configuration.deliveryThreshold = toCents(that.currentVas.configuration.deliveryThreshold);
      }

      const saveObj = {};
      Object.keys(that.currentVas.configuration).forEach(key => {
        if (JSON.stringify(that.currentVas.originalData[key]) !== JSON.stringify(that.currentVas.configuration[key])){
          saveObj[key] = that.currentVas.configuration[key];
        }
      })

      MerchantVasService.configureVas(saveObj, that.currentVas.id)
        .then(
          (ok) => {
            that.currentVas.configuration = ok.data;
            that.currentVas.configuration.deliveryCost /= 100;
            that.currentVas.configuration.deliveryThreshold /= 100;
            that.showVasConfigurationSuccess();
          }
        );

    };

    that.fillMenus = () => {

      CatalogService.getMenus().then((data) => {

        that.vasMenus = data;
        if (!that.vasMenus || that.vasMenus.length === 0) that.showVasConfigurationMenuError();

      });

    };

    $scope.disableButton = () => {
      if (that.getDays().some(function (el) { return el.error; }))
        return true;
      else
        return false;
    };

    const toCents = (amount) => {
      const a = '' + amount; // Making sure is a string
      return parseInt((a.replace(',', '.') * 100).toPrecision(12));
    };

    const init = () => {
      that.fillMenus();
      var merchantProfile = JSON.parse(StorageService.getLocalStorage('userContext'));
      MerchantVasService.getVasByType(that.currentVasTypeId, merchantProfile.business.id)
        .then(
          (response) => {
            that.currentVas = response.data;
            that.currentVas.configuration.deliveryCost /= 100;
            that.currentVas.configuration.deliveryThreshold /= 100;
            if (that.currentVas.configuration.deliveryArea) {
              that.setShapes(that.currentVas.configuration.deliveryArea);
            }
            that.setDays(that.currentVas.configuration.openingHours);
            if (!that.currentVas.configuration.deliveryType) {
                that.currentVas.configuration.deliveryType = 'DEFAULT';
                that.currentVas.configuration.deliveryAreaType = 'ITALY';
            }
            that.currentVas.originalData = JSON.parse(JSON.stringify(that.currentVas.configuration));
          },
          (error) => {
            alert('error retrieving the vas!');
          }
        );
    };

    that.$onInit = init;



  }

}

export default orderAndDeliveryController;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/orderAndDelivery/orderAndDelivery.controller.js
 **/